module.exports = __webpack_public_path__ + "images/search-icon-541a0e5c.png";